module.exports = __webpack_public_path__ + "static/media/above-fold-mobile.8190e005.svg";